import { Component, Ref, Prop } from 'vue-property-decorator';
import Vue from 'vue';
import { BModal } from 'bootstrap-vue';
import { List } from '@/models/list/list';
import { IMailWizzEntity } from '@/models/common/mailwizz-entity';
import { INamedEntity } from '@/models/common/named-entity';
import { CreateCampaignRequest } from '@/models/campaign/create-campaign-request';
import { campaignService } from '@/services/campaign-service';
import { uniqueNames } from '@/views/create-testcase/components/testcase-generator/unique-names';
import { CampaignResponse } from '@/models/campaign/campaign-response';

@Component
export default class CreateDraftCampaignComponent extends Vue {

    readonly selectListFormatter = (entity: IMailWizzEntity & INamedEntity) => { return { text: entity.name, value: entity } }
    
    private campaign: CampaignResponse = null
    private campaignList: List = null
    private campaignName: string = null
    private lockTrackingDomain: boolean = true
    private saving: boolean = false
    private campaignLink: string = null

    invalidFields: string[] = []

    @Prop() lists: List[]

    @Ref() private modal: BModal

    show(campaign: CampaignResponse) {
        this.campaign = campaign
        this.campaignName = campaign.mailWizzName
        this.campaignList = null
        this.campaignLink = null
        this.modal.show()
    }

    async save() {

        this.validate()
        if (this.invalidFields.length > 0) return

        this.saving = true
        try {
            const request = new CreateCampaignRequest()
            request.name = this.campaignName
            request.subject = this.processSubject(this.campaign.subject)
            request.body = this.campaign.body
            request.fromName = this.campaign.fromName
            request.fromEmail = this.campaign.fromEmail
            request.replyTo = this.campaign.replyTo
            request.listId = this.campaignList.mailWizzEntityId
            request.deliveryServerId = this.campaign.deliveryServerId
            request.trackingDomainId = this.campaign.trackingDomainId
            request.status = 'draft'
            request.lockTrackingDomain = this.lockTrackingDomain

            const response = await campaignService.create<any>({
                data: request
            })

            if (response && response.campaignId) {
                this.campaignLink = campaignService.generateCampaignLink(response.campaignId)
            }

            //this.modal.hide()
        }
        finally {
            this.saving = false
        }
    }

    processSubject(subject: string) {
        // TODO: Store original subject somewhere instead
        const usedNames = uniqueNames.filter(name => subject.indexOf(`${name}, `) == 0)
        return uniqueNames.length > 0 ? subject.substring(usedNames[0].length + 1).trim()  : subject
    }

    validate() {
        this.clearValidation()
        if (!this.campaignName) this.invalidFields.push('name')
        if (!this.campaignList) this.invalidFields.push('list')
    }

    clearValidation() {
        if (this.invalidFields.length) {
            this.invalidFields.splice(0, this.invalidFields.length)
        }
    }

    getValidationState(fieldname: string) {
        return this.invalidFields.indexOf(fieldname) >= 0 ? false : null
    }
}